<template>
    <v-projects
        :title="$t('shared.list.cookies.title')"
        tool="cookie"
        :icon="rowIcon"
        :empty="emptyText"
    />
</template>

<script>
import { markRaw } from "vue";
import vProjects from "@/shared/views/vProjects.vue";
import { CookieIcon } from "@easy/ui/icons";

export default {
    name: "CookieListPage",
    components: { vProjects },
    computed: {
        rowIcon() {
            return markRaw(CookieIcon);
        },
        emptyText() {
            return {
                title: this.$t("shared.list.cookies.empty_title"),
                subtitle: this.$t("shared.list.cookies.empty_subtitle"),
                ctaLabel: this.$t("shared.list.cookies.new"),
            };
        },
    },
};
</script>
